export default __webpack_public_path__ + "static/media/three.0140d7e1.svg";